// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

/* eslint-disable no-new */
new Vue({
    el: '#app',
    render: function(createElement) {
        return createElement(App);
    }
})



/** WEBPACK FOOTER **
 ** ./src/main.js
 **/